import React from "react";
import "./CoCSpeechBubble.css";

export default function WardenSpeechBubble({
  children,
  tailDirection = "right",
}) {
  return (
    <div className={`warden-bubble warden-${tailDirection}`}>
      <div className="warden-inner">{children}</div>
      <div className={`warden-tail warden-tail-${tailDirection}`}></div>
    </div>
  );
}
